var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36493 1.28974C8.27541 1.19521 8.16812 1.12074 8.0497 1.07095C7.93129 1.02116 7.80427 0.997103 7.67651 1.00028C7.54876 1.00345 7.423 1.03379 7.30702 1.0894C7.19104 1.14502 7.08731 1.22473 7.00227 1.3236L1.23707 8.01773C1.08438 8.19504 0.999988 8.42441 1 8.66209V16.0325C1 16.2891 1.09833 16.5352 1.27337 16.7166C1.4484 16.8981 1.6858 17 1.93333 17H4.73333C4.98087 17 5.21827 16.8981 5.3933 16.7166C5.56833 16.5352 5.66667 16.2891 5.66667 16.0325V12.6463C5.66667 12.3897 5.765 12.1436 5.94003 11.9621C6.11507 11.7807 6.35246 11.6788 6.6 11.6788H9.4C9.64754 11.6788 9.88493 11.7807 10.06 11.9621C10.235 12.1436 10.3333 12.3897 10.3333 12.6463V16.0325C10.3333 16.2891 10.4317 16.5352 10.6067 16.7166C10.7817 16.8981 11.0191 17 11.2667 17H14.0667C14.3142 17 14.5516 16.8981 14.7266 16.7166C14.9017 16.5352 15 16.2891 15 16.0325V8.68821C14.9997 8.43481 14.9035 8.19164 14.7321 8.01096L8.36493 1.28974Z",
    stroke: "#DCDCEC",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutProperty);
export default __webpack_public_path__ + "static/media/about_property.9f3b29d298ef7cbf1901c577a5ac706a.svg";
export { ForwardRef as ReactComponent };